import { FC } from 'react'
import IconWrapper, { IconWrapperProps } from './IconWrapper'
import { ReactComponent as MyAcceptIcon } from './img/accept.svg'

type AcceptIconProps = IconWrapperProps

export const AcceptIcon: FC<AcceptIconProps> = ({ className, ...props }) => {
  return (
    <IconWrapper className={className} {...props}>
      <MyAcceptIcon />
    </IconWrapper>
  )
}
